import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import message from 'ant-design-vue/es/message'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import router from '@/router'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // timeout: 6000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 400) {
      console.log(data)
      const msg = data.message || data.Message || '请求参数错误'
      message.error(msg)
    } else if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    } else if (error.response.status === 500) {
      notification.error({
        message: 'Server Error',
        description: data.message || '服务器内部错误'
      })
    } else if (error.response.status === 502) {
      const msg = typeof data === 'string'
        ? data
        : (data && (data.message || data.Message)) || '上游服务调用失败'
      message.error(msg)
    } else if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: '系统提示',
        description: '当前没有权限，请登录'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
                    router.push('/');

            // window.location.reload()
          }, 1500)
        })
      }else{
        console.log('9999')
        // 跳转首页
        router.push('/');
      }
    } else {
      notification.error({
        message: 'Error',
        description: data.message || data.Message || '请求失败'
      })
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers[ACCESS_TOKEN] = 'Bearer '+token
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  return response.data
}, errorHandler)

// 创建 video axios 实例
const videoRequest = axios.create({
  baseURL: process.env.VUE_APP_VIDEO_API_BASE_URL,
  // timeout: 6000 // 请求超时时间
})

// video request interceptor
videoRequest.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  if (token) {
    config.headers[ACCESS_TOKEN] = 'Bearer ' + token
  }
  return config
}, errorHandler)

// video response interceptor
videoRequest.interceptors.response.use((response) => {
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

/**
 * 通用上传请求封装 (multipart/form-data)
 * 适用于需要上传文件以及其他参数的 API 接口
 * 
 * @param {string} url - 接口地址
 * @param {object} parameter - 参数对象（包含文件和其他参数）
 * @param {string} method - 请求方法 (默认: 'post')
 * @returns {Promise}
 */
const upload = function (url, params, data, method = 'post', baseApi=false) {
  const formData = new FormData()

  if (data) {
    Object.keys(data).forEach(key => {
      const value = data[key]

      // 处理数组 (例如多文件上传或多选值)
      if (Array.isArray(value)) {
        value.forEach(item => {
          // 如果项不为 null/undefined，则追加
          if (item !== null && item !== undefined) {
            formData.append(key, item)
          }
        })
      }
      // 处理普通值
      else if (value !== null && value !== undefined) {
        formData.append(key, value)
      }
    })
  }

  return request({
    baseURL: baseApi ? process.env.VUE_APP_VIDEO_API_BASE_URL :
     process.env.VUE_APP_API_BASE_URL,
    url: url,
    method: method,
    params: params,
    data: formData,
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // }
  })
}

export default request

export {
  installer as VueAxios,
  request as axios,
  videoRequest,
  upload
}
